<template>
  <section class="pictureadsstyle">
    <!-- 表单 -->
    <el-form
      label-width="80px"
      :model="datas"
      size="small"
      :rules="rules"
      style="margin-top: 20px"
    >
      <div style="margin: 20px; font-weight: bold">图片</div>
      <!-- 标题内容 -->
      <el-form-item label="标题：">
        <div class="weiz">
          <div class="ml35">
            <el-input
              v-model="datas.pictureTitle"
              placeholder="请输入图片标题"
              show-word-limit
            />
          </div>
        </div>
      </el-form-item>
      <!-- 标题大小 -->
      <el-form-item
        label="字号："
        prop="pictureTitleSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select
              v-model="datas.pictureTitleSize"
              placeholder="请选择字号"
            >
              <el-option
                v-for="item in wordSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 字体 -->
      <el-form-item
        label="字体："
        prop="fontWeight"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontFamily" placeholder="请选择字体">
              <el-option
                v-for="item in fontFamilyOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 标题颜色 -->
      <el-form-item label="颜色：">
        <div class="weiz">
          <div class="ml35">
            <!-- 颜色选择器 -->
            <el-color-picker
              v-model="datas.pictureTitleColor"
              show-alpha
              class="picke"
              :predefine="predefineColors"
            >
            </el-color-picker>
          </div>
        </div>
      </el-form-item>
      <!-- 标题位置(上边距) -->
      <el-form-item label="标题位置(上边距)" class="lef">
        <el-slider
          v-model="datas.pictureTitleTop"
          :max="140"
          :min="0"
          input-size="mini"
          show-input
        >
        </el-slider>
      </el-form-item>
      <!-- 标题位置(左边距) -->
      <el-form-item label="标题位置(左边距)" class="lef">
        <el-slider
          v-model="datas.pictureTitleLeft"
          :max="250"
          :min="0"
          input-size="mini"
          show-input
        >
        </el-slider>
      </el-form-item>
      <!-- 标题位置(左边距) -->
      <el-form-item label="容器高度" class="lef">
        <el-slider
          v-model="datas.imageHeight"
          :max="250"
          :min="0"
          input-size="mini"
          show-input
        >
        </el-slider>
      </el-form-item>
      <!-- 图片 -->
      <el-form-item label="图片" class="lef">
        <div class="weiz">
          <div class="ml35">
            <!-- 上传图片 -->
            <PreviewUploadImage
              :uploadUrl="$uploadUrl"
              v-model="fileList"
              @upload-success="handleUploadSuccess"
            />
            <!-- <UploadImg ref="upload" @uploadInformation="uploadInformation" /> -->
          </div>
        </div>
      </el-form-item>

      <div style="margin: 20px; font-weight: bold">导航组</div>
      <!-- 文字高度 -->
      <el-form-item label="文字高度" class="lef">
        <el-slider
          v-model="datas.textHeight"
          :max="50"
          :min="24"
          input-size="mini"
          show-input
        >
        </el-slider>
      </el-form-item>
      <!-- 背景颜色 -->
      <el-form-item class="lef" label="背景：">
        <div class="weiz">
          <div class="ml35">
            <!-- 背景颜色子组件 -->
            <LinkInput :datas="datas" field="backgroundColor" defaultColor="defaultBackgroundColor" type="color" />
          </div>
        </div>
      </el-form-item>
      <!-- 文字颜色 -->
      <el-form-item class="lef" label="文字颜色">
        <div class="weiz">
          <div class="ml35">
            <!-- 颜色选择器 -->
            <el-color-picker
              v-model="datas.textColor"
              show-alpha
              class="picke"
              :predefine="predefineColors"
            >
            </el-color-picker>
          </div>
        </div>
      </el-form-item>
      <div>
        <vuedraggable v-model="datas.imageList" v-bind="dragOptions">
          <transition-group>
            <section
              v-for="(item, index) in datas.imageList"
              :key="item + index"
            >
              <div class="imgBanner" style="border: 1px solid red">
                <!-- 图片 -->
                <div class="imag">
                  <img
                    draggable="false"
                    :src="item.src"
                    alt=""
                    @click="handleUploadImage(item, index)"
                  />
                </div>
                <div style="width: 100%">
                  <!-- 标题和链接 -->
                  <div class="imgText" style="align-items: center">
                    <el-input
                      v-model="item.text"
                      placeholder="导航名称"
                      size="mini"
                    />
                    <i class="el-icon-delete" @click="deleteimg(index)" />
                  </div>
                  <!-- 标题和链接 -->
                  <div style="padding-left: 20px; margin-top: 10px">
                    <CustomSelectList
                      :id="datas.id"
                      :datas="item"
                      :isShow="true"
                      :index="index"
                    />
                  </div>
                </div>
              </div>
            </section>
          </transition-group>
        </vuedraggable>
      </div>
      <!-- 标题大小 -->
      <!-- <el-form-item
        label="字号："
        prop="pictureTitleSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select
              v-model="datas.pictureTitleSize"
              placeholder="请选择字号"
            >
              <el-option
                v-for="item in pictureTitleSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item> -->
    </el-form>
    <!-- 上传图片 -->
    <image-select-modal
      ref="imageSelectModal"
      :isImageLib="false"
      :activeTab="'myFiles'"
      :visible.sync="showImageModal"
      @select="handleImageSelect"
    />
  </section>
</template>

<script>
import vuedraggable from "vuedraggable"; //拖拽组件
import {
  wordSizeOptions,
  fontFamilyOptions,
  predefineColors,
} from "@/utils/defaultData.js";
export default {
  name: "picturenavgroupstyle",
  components: { vuedraggable },
  props: {
    datas: Object,
  },
  data() {
    return {
      fileList: [],
      wordSizeOptions: wordSizeOptions,
      fontFamilyOptions: fontFamilyOptions,
      predefineColors: predefineColors,
      optionsType: [
        {
          type: "10",
          name: "内部链接",
        },
        {
          type: "11",
          name: "外部链接",
        },
      ], // 选择跳转类型
      dragOptions: {
        animation: 200,
      },
      emptyText: "",
      rules: {
        // wordSize: [{ required: true, validator: checkAge, trigger: "blur" }],
        // descriptionSize: [
        //   { required: true, validator: checkAge, trigger: "blur" },
        // ],
        // wordWeight: [{ required: true, validator: kon, trigger: "blur" }],
        // descriptionWeight: [
        //   { required: true, validator: kon, trigger: "blur" },
        // ],
      },
      showImageModal: false, //显示上传图片弹窗
      currentItemIndex: {}, //当前点击的图片项
    };
  },

  created() {},

  methods: {
    // 上传图片点击事件
    handleUploadImage(item, index) {
      this.showImageModal = true;
      this.currentItemIndex = index;
      console.log("handleUploadImage方法回调", item, index, this.datas);
    },
    // 上传图片确定回调函数
    handleImageSelect(res) {
      this.datas.imageList[this.currentItemIndex].src = res.url;
      console.log(
        "image-select-modal确定函数回调方法",
        res,
        this.datas,
        this.currentItem,
      );
    },
    // 上传图片成功回调
    handleUploadSuccess(fileList, res) {
      // 更新上传的图片
      this.datas.bgImg = res.data;

      console.log("上传图片了handleUploadSuccess成功回调函数", res, this.datas);
    },
    // 提交
    uploadInformation(res) {
      this.datas.imageList.push({
        src: res,
        text: "",
        http: {},
      });
    },

    /* 删除图片 */
    deleteimg(index) {
      this.datas.imageList.splice(index, 1);
    },
  },

  computed: {
    styleText() {
      let data;
      if (this.datas.swiperType === 0) data = "一行一个";
      if (this.datas.swiperType === 1) data = "轮播海报";
      if (this.datas.swiperType === 2) data = "多图单行";
      if (this.datas.swiperType === 3) data = "立体模式";
      if (this.datas.swiperType === 4) data = "导航横向滑动";

      return data;
    },
  },
};
</script>

<style scoped lang="scss">
.pictureadsstyle {
  width: 100%;
  left: 0;
  top: 0;
  padding: 0 10px;
  box-sizing: border-box;

  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }

  .lef {
    ::v-deep.el-form-item__label {
      text-align: left;
    }
  }

  /* 轮播图样式 */
  .swiperType {
    display: flex;
    justify-content: space-around;
    align-items: center;
    span {
      display: inline-block;
      width: 58px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      background: #ebedf0;
      color: #979797;
      border: 1px solid #fff;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        border: 1px solid #155bd4;
        color: #155bd4;
      }

      &.active {
        border: 1px solid #155bd4;
        background-color: #e0edff;
        color: #155bd4;
      }
    }
  }

  /* 圆角 */
  .borrediu {
    span {
      display: inline-block;
      width: 48px;
      height: 26px;
      text-align: center;
      line-height: 26px;
      background: #ebedf0;
      color: #979797;
      border: 1px solid #fff;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        border: 1px solid #155bd4;
        color: #155bd4;
      }

      &.active {
        border: 1px solid #155bd4;
        background-color: #e0edff;
        color: #155bd4;
      }
    }
  }

  ::v-deep.radi .el-radio {
    margin-right: 8px;
  }

  ::v-deep.radi1 .el-radio {
    margin-right: 7px;
    .el-radio__label {
      padding-left: 5px;
    }
  }

  /* 上传图片按钮 */
  .uploadImg {
    width: 345px;
    height: 40px;
    margin-top: 20px;
  }

  // 上传弹框内容部分
  ::v-deep.uploadIMG .el-dialog__body {
    height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
  }

  .disable {
    ::v-deep.el-upload {
      display: none !important;
    }
  }

  /* 图片广告列表 */
  .imgBanner {
    padding: 6px 12px;
    margin: 16px 7px;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(10, 42, 97, 0.2);
    display: flex;
    position: relative;

    /* 删除图标 */
    .el-icon-circle-close {
      position: absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;
      font-size: 19px;
    }

    /* 图片 */
    .imag {
      width: 65px;
      height: 60px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      margin-top: 5px;
      cursor: pointer;
      align-items: center;
      display: flex;
      img {
        width: 77%;
        height: 70%;
        display: inline-block;
      }
      span {
        background: rgba(0, 0, 0, 0.5);
        font-size: 12px;
        position: absolute;
        left: 0px;
        bottom: 0px;
        display: inline-block;
        width: 100%;
        text-align: center;
        color: #fff;
        height: 20px;
        line-height: 20px;
      }
    }

    /* 图片字 */
    .imgText {
      display: flex;
      box-sizing: border-box;
      padding-left: 20px;
      justify-content: space-between;
      .el-icon-delete {
        padding-left: 10px;
        cursor: pointer;
      }
      .imgText-top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .imgText-top-r {
          flex: 1;
          text-align: center;
          span {
            margin-right: 10px;
          }
        }
        ::v-deep.el-input,
        .el-input--mini {
          flex: 1;
        }
      }
      .select-type {
        display: flex;
        ::v-deep.el-select {
          .el-input {
            input {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
</style>
